import clsx from 'clsx';
import React, {
  createContext, FC, useState, useCallback, useContext, useEffect,
} from 'react';

interface Interface {
  notify: (args: JSX.Element) => () => void;
  onClose: () => Promise<void>;
}

export const NotifyContext = createContext<Interface>({} as Interface);

export function useNotify(): Interface {
  return useContext(NotifyContext);
}

const Notify: FC = ({ children }) => {
  const [args, setArgs] = useState<JSX.Element | undefined>(undefined);

  const notify = useCallback((arg: JSX.Element) => (): void => {
    setArgs(arg);
  }, []);

  const onClose = useCallback(async () => {
    setArgs(undefined);
  }, []);

  useEffect(() => {
    if (args) {
      document.body.style.overflow = 'hidden';
    }
    return (): void => {
      document.body.style.overflow = '';
    };
  }, [args]);

  return (
    <NotifyContext.Provider
      value={{
        notify,
        onClose,
      }}
    >
      {children}
      <div className={clsx('notify__overlay', { active: Boolean(args) })}>
        <div className="notify__container">
          <div className="notify__content">
            {
              args && (
                args
              )
            }
          </div>
        </div>
      </div>
    </NotifyContext.Provider>
  );
};

export default Notify;
